export default [
  {
    path: '/app/static_services',
    name: 'Static_services',
    component: () => import('@/views/Admin/Static_services/Index.vue'),
    meta: {
      pageTitle: 'Static Sayfalar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_STATIC_SERVICES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/static_services/add',
    name: 'Static_servicesAdd',
    component: () => import('@/views/Admin/Static_services/Add.vue'),
    meta: {
      pageTitle: 'Static Sayfalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/static_services',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_STATIC_SERVICES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/static_services/edit/:id',
    name: 'Static_servicesEdit',
    component: () => import('@/views/Admin/Static_services/Edit.vue'),
    meta: {
      pageTitle: 'Static Sayfalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/static_services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_STATIC_SERVICES_EDIT',
      action: 'read',
    },
  },
]
